<app-widget-option [categories]="['LAYERS', 'PERCENT']" [label]="'MAX'" [limitedTo]="['gauge']">
  <div app-widget-option-content>
    <app-number [value]="widgetLayers.layer(current).gaugeMax" (sendValue)="receiveValue($event)" [color]="color" [step]="20"></app-number>
  </div>
</app-widget-option>